<div  class="{{getDirection() =='rtl'?'base-rtl':'base-ltr'}}">

    <p-progressBar mode="indeterminate" *ngIf=" global.progressBar"
                   [style]="{'height': '6px','position': 'fixed','width': '100%','border-radius':'0px'}"></p-progressBar>
    <p-toast class="{{getDirection() =='rtl'?'base-rtl':'base-ltr'}}" position="bottom-left"
             [hideTransitionOptions]="'0ms'"></p-toast>
    <p-confirmDialog class="{{getDirection() =='rtl'?'base-rtl':'base-ltr'}}" [style]="{width: '420px '}"
                     [baseZIndex]="10000"></p-confirmDialog>
    <div  style="z-index: 20;position: relative;" >
        <app-top-bar *ngIf="topLoad && loadMenu" #topbar [items]="itemsTopBar" [top_bar]="top_bar" [top_bar_Link]="top_bar_Link" class="lg:block xl:block hidden"></app-top-bar>
        <app-menu-bar *ngIf="topLoad && loadMenu"  #menubar [items]="itemsMainMenu" [topItems]="itemsTopBar" [perform]="perform" [dashboardLink]="dashboardInfo" id="header" ></app-menu-bar>
    </div>
    <div *ngIf="topLoad"  #center id="center" (click)="responsiveCloseMenu()" class="{{sidbarStyle?'':'offf'}} center   "

         [@routeAnimations]="outlet.isActivated ? outlet.activatedRoute : '' && outlet.activatedRouteData
    && outlet.activatedRouteData['animation']">
        <div class="ui-g-12 " spellcheck="false">
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
    </div>

    <footer>
        <div>
            <app-performance-section *ngIf="topLoad"></app-performance-section>
        </div>
        <div>
            <app-footer *ngIf="topLoad" ></app-footer>
        </div>


    </footer>

</div>